var _a;
import { UrlMappingsKeys } from '../url-mappings-keys';
export var bookingsMapping = (_a = {},
    _a[UrlMappingsKeys.BOOKINGS_SERVICE_PAGE] = {
        variables: ['slug'],
        required: ['slug'],
        defaultPrefix: 'booking-calendar',
    },
    _a);
//# sourceMappingURL=bookings.js.map